export class MemberDistributionCenterEntity {
  id: number;
  name: string;

  constructor(entity?: MemberDistributionCenterEntity) {
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.id = 0;
      this.name = '';
    }
  }
}
